// Account-level lifecycle status returned by the account-status endpoint.
// Drives most dashboard states for verified accounts.
export const INVESTOR_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  KYC_REQUIRED: 'kyc_required',
  PENDING_REVIEW: 'pending_review',
  SUSPENDED: 'suspended',
  DEACTIVATED: 'deactivated',
  BLOCKED: 'blocked',
} as const

export type InvestorStatusKey = keyof typeof INVESTOR_STATUS
export type InvestorStatusValue = (typeof INVESTOR_STATUS)[InvestorStatusKey]

// Onboarding flow phase — separate from KYC because KYC is one step inside
// onboarding. `completed` means every required step is done; optional steps
// can still be outstanding (see `profile_completed`).
export const ONBOARDING_STATUS = {
  REGISTERED: 'registered',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
} as const

export type OnboardingStatusKey = keyof typeof ONBOARDING_STATUS
export type OnboardingStatusValue = (typeof ONBOARDING_STATUS)[OnboardingStatusKey]
